'use client'

/**
 * Input monetario com mascara brasileira (R$ X.XXX,XX). Mantem o valor em
 * centavos internamente — consumidor recebe number|null em centavos via
 * onChange. Digitar so aceita digitos; cada digito empurra os centavos
 * (estilo POS): '1' -> R$ 0,01, '15' -> R$ 0,15, '150' -> R$ 1,50.
 */
export default function CurrencyInput({
    valueCents,
    onChange,
    placeholder,
    disabled,
    className,
}: {
    valueCents: number | null
    onChange: (cents: number | null) => void
    placeholder?: string
    disabled?: boolean
    className?: string
}) {
    const display = formatCents(valueCents)

    const handleChange = (raw: string) => {
        const digits = raw.replace(/\D/g, '')
        if (!digits) {
            onChange(null)
            return
        }
        const cents = parseInt(digits, 10)
        onChange(Number.isFinite(cents) ? cents : null)
    }

    return (
        <input
            inputMode="numeric"
            className={className ?? 'input input-bordered input-sm'}
            value={display}
            onChange={(e) => handleChange(e.target.value)}
            placeholder={placeholder ?? 'R$ 0,00'}
            disabled={disabled}
        />
    )
}

function formatCents(cents: number | null): string {
    if (cents == null) return ''
    const reais = cents / 100
    return reais.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })
}
